module.exports = __webpack_public_path__ + "static/media/output.91f93252.png";